/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { REQUEST_STATUS } from "@/ts/enums/RequestStatus";
import { MappedQuizResult } from "@/ts/interfaces/Reporting/QuizResultsInterface";
import { getQuizResultsByActivityIdThunk } from "../thunks";

interface QuizResultsState {
    status: REQUEST_STATUS;
    error: string | null;
    data: MappedQuizResult | null;
}

const initialState: QuizResultsState = {
    status: REQUEST_STATUS.IDLE,
    error: null,
    data: null,
};

const quizResultsSlice = createSlice({
    name: "reporting/quizResults",
    initialState,
    reducers: {
        resetQuizResultsState: () => initialState,
        clearQuizResults: state => {
            state.status = REQUEST_STATUS.IDLE;
            state.error = null;
            state.data = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getQuizResultsByActivityIdThunk.pending, state => {
                state.status = REQUEST_STATUS.PENDING;
                state.error = null;
            })
            .addCase(
                getQuizResultsByActivityIdThunk.fulfilled,
                (state, action: PayloadAction<MappedQuizResult>) => {
                    state.status = REQUEST_STATUS.SUCCESS;
                    state.data = action.payload;
                }
            )
            .addCase(getQuizResultsByActivityIdThunk.rejected, (state, action) => {
                state.status = REQUEST_STATUS.ERROR;
                state.error =
                    (action.payload as string) ?? action.error.message ?? "Unknown error";
                state.data = null;
            });
    },
});

export const { resetQuizResultsState, clearQuizResults } = quizResultsSlice.actions;
export default quizResultsSlice.reducer;
